// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1841":"4f8c4484","3367":"5e0ebfdb"}[chunkId] + ".css";
};